var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data d-flex align-center justify-center flex-column"},[_c('icon-search-big'),_c('div',{staticClass:"no-data__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }